import React, { Component } from 'react';

import { Tabs } from 'antd';
import TabHistory from './TabHistory';
import TabContract from './TabContract';
import TabFile from './TabFile';

const { TabPane } = Tabs;
class ClientDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  callback = () => {};

  render() {
    return (
      <Tabs defaultActiveKey="1" onChange={this.callback}>
        <TabPane tab="动态" key="1">
          <TabHistory />
        </TabPane>
        <TabPane tab="合同" key="2">
          <TabContract />
        </TabPane>
        <TabPane tab="资料" key="3">
          <TabFile />
        </TabPane>
      </Tabs>
    );
  }
}

export default ClientDetail;



// WEBPACK FOOTER //
// ./src/components/client/manage/ClientDetail.js